/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiPersonStatus,
    InternalApiPersonStatusFromJSON,
    InternalApiPersonStatusToJSON,
} from '../models';

export interface UpdatePersonStatusRequest {
    personId: string;
    internalApiPersonStatus: InternalApiPersonStatus;
}

/**
 * 
 */
export class PersonStatusInternalApi extends runtime.BaseAPI {

    /**
     * Person status update
     */
    async updatePersonStatusRaw(requestParameters: UpdatePersonStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling updatePersonStatus.');
        }

        if (requestParameters.internalApiPersonStatus === null || requestParameters.internalApiPersonStatus === undefined) {
            throw new runtime.RequiredError('internalApiPersonStatus','Required parameter requestParameters.internalApiPersonStatus was null or undefined when calling updatePersonStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/status`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiPersonStatusToJSON(requestParameters.internalApiPersonStatus),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Person status update
     */
    async updatePersonStatus(requestParameters: UpdatePersonStatusRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updatePersonStatusRaw(requestParameters, initOverrides);
    }

}
